export default __webpack_public_path__ + "static/media/28.a571aea7.png";